import styled from "styled-components";
import {Descriptions, Avatar, Button, Tag, Table, Typography, List, Select} from "antd";
import {MinusCircleFilled, FileImageFilled} from "@ant-design/icons";

const {Text} = Typography;

export const DescriptionContainer = styled(Descriptions)`
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    @media (max-width: 768px) {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
`;

export const OrderNumber = styled(Text)`
    font-weight: bold;
`;

export const MergedOrderStats = styled(Text)`
    font-weight: bold;
    float: left;
`;

export const OrderTotalTime = styled(Text)`
    font-weight: bold;
    float: right;
`;

export const TransferInfoContainer = styled.div`
    padding: 0 35px 35px;
    margin-top: 5px;
    margin-bottom: 20px;
    border: 1px solid #f0f0f0;
`;

export const TransferLogList = styled(List)`
    .ant-list-item {
        padding: 6px 0;
    }
    .ant-list-item-meta-title {
        margin-bottom: 0px;
        font-weight: 300;
    }
    .ant-list-item-meta {
        margin-bottom: 0px;
    }
`;

export const TransferDescription = styled.p`
    font-size: 12px;
    color: black;
`;

export const StepContainer = styled.div`
    position: relative;
    padding: 0 35px 35px;
    border: 1px solid #f0f0f0;
    margin-bottom: 30px;
    margin-top: 5px;
    .ant-steps-item-content {
        width: auto;
    }
`;

export const MapContainer = styled.div`
    width: 100%;
    max-width: 100vw;
    height: 350px;
    min-height: 350px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    z-index: 1;
    position: relative;
    transition: all 0.3s ease;
    ${({mode}) =>
        mode == "fixed" &&
        `position: fixed;
        left: 105px;
        right: 25px;
        bottom: 40px;
        top: 95px;
        width: calc(100vw - 130px);
        height: calc(100vh - 135px);
        max-width: none;
        z-index: 1000;
        border-radius: 0;`}

    @media (max-width: 768px) {
        ${({mode}) =>
            mode == "fixed" &&
            `left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 100vw;
            height: 100vh;
            border: none;
            border-radius: 0;`}
    }

    .gmnoprint, .gm-style-cc, .gmnoprint a, .gmnoprint span {
        display: none !important;
    }
`;

export const MapTools = styled(Button)`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 5;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    svg {
        width: 1.5em;
        height: 1.5em;
        margin: 5px;
    }
`;

export const Marker = styled(Avatar)`
    position: absolute;
    background-color: ${props => props.color};
    transform: translate(-50%, -50%);
    border: 1px solid #021529;
    box-sizing: content-box;
    color: #021529;
    z-index: ${props => (props.$hover ? 2 : 1)};
    font-size: 14px !important;
    border-radius: ${props => props.$hover && "4px"};
    width: ${props => props.$hover && "auto"} !important;
    &:after {
        content: ${props => props.$hover && `"${props.text}"`};
        margin-left: 5px;
    }
    padding: ${props => props.$hover && "5px"} !important;
    transition: border-radius 0.1s;

    ${props =>
        props.$hover &&
        `
        > * {
            display: none;
        }
    `}
`;

export const TableTitle = styled.h3`
    margin: 15px 0%;
    font-size: 1.17em !important;
`;

export const TableOverflow = styled.div`
    width: 100%;
    max-width: 100vw;
    overflow-x: auto;
    overflow-y: visible;
`;

export const LeftButton = styled(Button)`
    padding-right: 50px;
    padding-left: 50px;
`;

export const MiddleButton = styled(Button)`
    margin-right: 20px;
    margin-left: 20px;
`;

export const RightButton = styled(Button)`
    float: right;
`;

export const AnnulmentButton = styled(Button)`
    display: ${props => (props.visible === "true" ? "none" : "block")};
    margin: auto;
    width: 90px;
`;

export const PassButton = styled(Button)`
    margin-top: 3px;
    margin-bottom: 10px;
    width: 90px;
`;

export const DetailTag = styled(Tag)`
    margin-bottom: 0.5rem;
    margin-left: 5px;
`;

export const SpinnerContainer = styled.div`
    position: absolute;
    width: calc(100% - 70px);
    height: calc(100% - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffffbf;
    z-index: 999;
`;

export const OrderTable = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
`;

export const OrderTableCustom = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
    tr.ant-table-expanded-row > td,
    tr.ant-table-expanded-row:hover > td {
        background: #cccccc !important;
    }

    /* Mobil responsive ayarlar */
    @media (max-width: 768px) {
        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 4px;
        }

        .ant-table-scroll {
            overflow-x: auto;
        }
    }
`;

export const PickupTableCustom = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
    tr.ant-table-expanded-row > td,
    tr.ant-table-expanded-row:hover > td {
        background: #cccccc !important;
    }

    .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
        margin: unset;
    }

    /* Mobil responsive ayarlar */
    @media (max-width: 768px) {
        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 4px;
        }

        .ant-table-scroll {
            overflow-x: auto;
        }
    }
`;

export const ReturnTableCustom = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
    tr.ant-table-expanded-row > td,
    tr.ant-table-expanded-row:hover > td {
        background: #cccccc !important;
    }

    .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
        margin: unset;
    }

    /* Mobil responsive ayarlar */
    @media (max-width: 768px) {
        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 4px;
        }

        .ant-table-scroll {
            overflow-x: auto;
        }
    }
`;

export const MapLegend = styled.div`
    position: absolute;
    right: 4px;
    bottom: 4px;
    background: rgba(255, 255, 255, 0.92);
    padding: 6px 10px;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    font-size: 10px;
    min-width: 155px;
    max-width: 210px;

    .legend-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        &:last-child {
            margin-bottom: 0;
        }

        .legend-line {
            width: 16px;
            height: 3px;
            margin-right: 6px;
            border-radius: 2px;
        }

        .legend-text {
            font-weight: 500;
            color: #333;
            white-space: nowrap;
        }
    }
`;

export const CancelButton = styled(Button)`
    margin-left: 8px;
`;

export const QueueModalContainer = styled.div`
    width: 600px;
    background-color: white;
    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const PrepModalContainer = styled.div`
    width: 600px;
    background-color: white;
    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const MinusCircleFilledIcon = styled(MinusCircleFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const FileImageFilledIcon = styled(FileImageFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const PrepDetailContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const MapStepRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

// Marker Styles
export const MarkerIcon = styled.div`
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.color || "#ff0000"};
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 1px solid #000;
    color: #000;
    font-size: 14px;
    font-weight: bold;
`;

export const CourierMarkerIcon = styled.div`
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.color || "#ff0000"};
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 2px solid #fff;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const MarkerPopupContainer = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 6px 14px;
    border-radius: 18px;
    background-color: ${props => props.$color || "#1677ff"};
    color: ${props => props.$textColor || "#1f1f1f"};
    font-weight: 600;
    line-height: 1.3;
    font-size: 13px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    white-space: nowrap;

    &:after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 8px 8px 0 8px;
        border-style: solid;
        border-color: ${props => props.$color || "#1677ff"} transparent transparent transparent;
    }
`;

export const MarkerPopupLabel = styled.span`
    color: inherit;
`;

// Map Container Styles
export const MapDiv = styled.div`
    width: 100%;
    height: 100%;
    min-height: 350px;

    @media (max-width: 768px) {
        min-height: 100%;
    }
`;

export const TableOverflowWithBorder = styled(TableOverflow)`
    border: 1px solid #e8e8e8;
`;

// Order Detail Styles
export const OrderDetailContainer = styled.div`
    background-color: #fafafa;
    margin: 8px 0;
    padding: 16px;
    border-radius: 0px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const OrderDetailTitle = styled.div`
    margin-bottom: 12px;
    font-size: 13px;
    color: #666;
    font-weight: 500;
`;

export const OrderDetailContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
    margin-bottom: 8px;
    padding: 12px 0 0 0;
`;

export const OrderDetailRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const OrderDetailRowCenter = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const OrderDetailLabel = styled.span`
    color: #888;
    font-size: 12px;
    font-weight: 500;
    min-width: 100px;
    flex-shrink: 0;
`;

export const OrderDetailValue = styled.div`
    color: #222;
    font-weight: 500;
    font-size: 13px;
    flex: 1;
`;

// Table Action Styles
export const TableActionGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 5px;
    align-items: center;
    min-width: 160px;
`;

export const ActionButton = styled(Button)`
    width: 100%;
    height: 28px;
    font-size: 16px;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: unset;
`;

export const PassButtonStyled = styled(ActionButton)`
    background-color: #ffd700;
    color: black;
    border-color: #ffd700;
`;

// Mobile Tab Styles
export const MobileTabContainer = styled.div`
    display: flex;
    margin-bottom: 8px;
    max-width: 100vw;
    overflow-x: hidden;
`;

export const MobileTabButton = styled.button`
    flex: 1;
    background: ${props => (props.active ? "#1890ff" : "#f5f5f5")};
    color: ${props => (props.active ? "#fff" : "#666")};
    border: 1px solid #d9d9d9;
    padding: 6px 8px;
    font-size: 13px;
    font-weight: 500;
    border-radius: ${props => (props.position === "left" ? "4px 0 0 4px" : "0 4px 4px 0")};
    cursor: pointer;
    min-height: 32px;
    outline: none;
    border-left: ${props => (props.position === "right" ? "none" : "1px solid #d9d9d9")};
`;

export const MobileContentContainer = styled.div`
    max-width: 100vw;
    overflow-x: hidden;
`;

// Mobile Button Styles
export const MobileButtonContainer = styled.div`
    width: 100%;
`;

export const MobileButton = styled(Button)`
    width: 100%;
    margin-bottom: 8px;
`;

// Table Row Styles
export const TableRowSpan = styled.span`
    background: ${props => props.color};
    border: 3px solid ${props => props.color};
    border-radius: 50%;
    box-shadow: 0 0 0 1px black;
    cursor: pointer;
`;

// Product Table Container
export const ProductTableContainer = styled.div`
    background-color: #fafafa;
    margin: 8px 0;
    padding: 16px;
    border-radius: 0px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

// Tooltip Styles
export const TooltipSpan = styled.span`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100px;
`;

export const DistanceSpan = styled.span`
    border-bottom: 1px dotted #999;
`;

// Main Container
export const MainContainer = styled.div`
    max-width: 100vw;
    overflow-x: hidden;
`;
